import { cssColorValue, IconArrowTopRight, Text, } from '@spotify-internal/encore-web/core';
import React from 'react';
import styled, { css } from 'styled-components';
import { useS4AMastheadContext } from '../../S4AMastheadProvider';
import { icons } from '../../../utils/Icons';
const visibleIcon = css `
  opacity: 100%;
  [dir='ltr'] & {
    padding-inline-start: ${({ size }) => {
    if (size === 'large') {
        return '8px';
    }
    if (size === 'medium') {
        return '6px';
    }
    return '4px';
}};
  }
  [dir='rtl'] & {
    padding-inline-end: ${({ size }) => {
    if (size === 'large') {
        return '8px';
    }
    if (size === 'medium') {
        return '6px';
    }
    return '4px';
}};
    padding-inline-start: 0px;
  }
`;
const TextLinkWrapper = styled.a `
  // override default link styling
  text-decoration: none;
  color: inherit;
  border: none;
  outline: none;
  display: inline-block;
  padding-bottom: ${({ size }) => {
    if (size === 'large') {
        return '4px';
    }
    if (size === 'medium') {
        return '3px';
    }
    return '2px';
}};

  // underline non hover
  background-image: ${({ color }) => color
    ? `linear-gradient(${color}, ${color})`
    : `linear-gradient(${cssColorValue('textBase')}, ${cssColorValue('textBase')})`};
  background-repeat: no-repeat;
  background-size: ${({ size }) => (size === 'large' ? '0% 4px' : '0% 2px')};
  background-position-y: 100%;
  background-position-x: 0%;
  [dir='rtl'] & {
    background-position-x: 100%;
  }
  transition: background-size cubic-bezier(0, 0, 1, 0) 0.2s,
    background-position cubic-bezier(0, 0, 1, 0) 0.2s;

  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: ${({ color }) => color || cssColorValue('textBase')};
  }

  // gap between text and svg icon
  .svgIcon {
    padding-inline-start: ${({ size }) => {
    if (size === 'large') {
        return '8px';
    }
    if (size === 'medium') {
        return '6px';
    }
    return '4px';
}};
  }

  .newTabIcon {
    display: ${({ showIcon }) => (showIcon ? 'flex' : 'none')};
    opacity: 0%;
    padding-inline-start: 0px;
    padding-inline-end: 0px;
    transition: padding-inline-start cubic-bezier(0, 0, 1, 0) 0.2s,
      padding-inline-end cubic-bezier(0, 0, 1, 0) 0.2s,
      opacity cubic-bezier(0, 0, 1, 0) 0.2s;

    @media (hover: none) {
      ${visibleIcon}
    }
  }

  :focus,
  :focus-visible,
  :hover {
    @media (hover: hover) {
      outline: none;
      // triggers the underline animation
      background-size: ${({ size }) => size === 'large' ? '100% 4px' : '100% 2px'};
      transition: all cubic-bezier(0, 0, 0, 1) 0.45s;

      .newTabIcon {
        // animates the new tab arrow from left to right
        // and adds padding between it and the text
        transition: padding-inline-start cubic-bezier(0, 0, 0, 1) 0.45s,
          padding-inline-end cubic-bezier(0, 0, 0, 1) 0.45s,
          opacity cubic-bezier(0, 0, 0, 1) 0.45s;
        ${visibleIcon}
      }
    }
  }
`;
const getTextVariant = (size) => {
    switch (size) {
        case 'xsmall':
            return 'bodySmallBold';
        case 'small':
            return 'bodyMediumBold';
        case 'medium':
            return 'titleSmall';
        case 'large':
            return 'titleLarge';
        default:
            return 'bodyMediumBold';
    }
};
export const TextLink = ({ label, href, trackingCategory, trackingLabel, color, size, openInNewTab = false, svgIcon, }) => {
    const Icon = svgIcon ? icons[svgIcon] : null;
    const { getLinkProps } = useS4AMastheadContext();
    const props = getLinkProps({
        trackingAttributes: [trackingCategory, trackingLabel, 'click'],
        href: href,
        openInNewTab: openInNewTab,
    });
    return (React.createElement(TextLinkWrapper, Object.assign({ color: color, size: size, showIcon: openInNewTab, tabIndex: 0 }, props),
        React.createElement("div", { className: "content" },
            React.createElement(Text, { variant: getTextVariant(size) }, label),
            Icon && (React.createElement(Icon, { className: "svgIcon", size: size === 'medium' ? 'small' : size })),
            openInNewTab && (React.createElement(IconArrowTopRight, { className: "newTabIcon", size: size === 'medium' ? 'small' : size })))));
};
//# sourceMappingURL=index.js.map